import styled from '@emotion/styled';
import { Constants } from '@seedlang/constants';
import { CharacterLimit, FieldLabel, StyledTextarea } from 'components/review/review_create_styles';
import { observer } from 'mobx-react';
import React from 'react';

const ReviewNoteLink = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  font-weight: normal;
  padding: 0;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

@observer
class ReviewCreateNote extends React.Component {

  static defaultProps = {
    note: '',
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.showReviewNoteInput &&
          <React.Fragment>
            <FieldLabel
              name='review_note'
              label='Review Note'
            />
            <StyledTextarea
              value={this.props.note}
              onChange={e => this.props.onSetNote(e.target.value)}
              maxLength={Constants.REVIEW_CARD_MAX_NOTE_LENGTH}
            />
            {
              this.props.note.length > Constants.REVIEW_CARD_CHARACTER_LIMIT_DISPLAY_THRESHOLD &&
              <CharacterLimit warning={this.props.note.length >= Constants.REVIEW_CARD_MAX_NOTE_LENGTH}>
                {this.props.note.length}/{Constants.REVIEW_CARD_MAX_NOTE_LENGTH} characters
              </CharacterLimit>
            }
          </React.Fragment>
        }
        {
          !this.props.showReviewNoteInput &&
          <ReviewNoteLink
            onClick={this.props.onShowReviewNoteInput}
            type='button'
          >
            <i
              className='fa fa-pencil'
              style={{ marginRight: 5 }}
            />
            Add Review Note
          </ReviewNoteLink>
        }
      </React.Fragment>
    );
  }
}

export default ReviewCreateNote;
